var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeezer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 8.51667H17.675V11.0392H22V8.51667ZM21 9.51667V10.0392H18.675V9.51667H21ZM22 12.0283H17.6758V14.5508H22V12.0283ZM21 13.0283V13.5508H18.6758V13.0283H21ZM22 15.5408H17.675L17.6758 15.5417V18.0658H22V15.5408ZM21 16.5408V17.0658H18.6758V16.5408H21ZM2 15.5408V18.0658H6.325V15.5417L2 15.5408ZM5.325 16.5408H3V17.0658H5.325V16.5408ZM7.225 14.5508H11.5492V12.0283H7.225V14.5508ZM8.225 13.5508V13.0283H10.5492V13.5508H8.225ZM7.225 11.0392H11.5492V8.51667H7.225V11.0392ZM8.225 10.0392V9.51667H10.5492V10.0392H8.225ZM12.4508 12.0283V14.5508H16.7758V12.0283H12.4508ZM13.4508 13.0283H15.7758V13.5508H13.4508V13.0283ZM12.4508 15.5408V18.0658H16.7758V15.5417L12.4508 15.5408ZM15.7758 16.5408V17.0658H13.4508V16.5408H15.7758ZM11.5492 15.5417L7.22417 15.5408L7.225 15.5417V18.0658H11.5492V15.5417ZM10.5492 16.5408V17.0658H8.225V16.5408H10.5492ZM17.675 7.525V5H22V7.525H17.675ZM21 6.525V6H18.675V6.525H21Z",
    fill: "#333333"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeezer);
export default __webpack_public_path__ + "static/media/deezer.ad03f589a23bf9c3fed746ba487126a5.svg";
export { ForwardRef as ReactComponent };